(function () {
  function buildHref(link, variantTitle) {
    const whatsappNumber =
      link.getAttribute('data-whatsapp-number') || link.dataset.whatsappNumber || '';
    const productTitle = link.getAttribute('data-product-title') || link.dataset.productTitle || '';
    const productUrl = link.getAttribute('data-product-url') || link.dataset.productUrl || '';
    let message = 'Hi, I would like to order ' + productTitle;
    if (variantTitle && variantTitle !== 'Default Title') {
      message += ' (' + variantTitle + ')';
    }
    message += '. ' + productUrl;
    return 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(message);
  }

  function initWhatsAppLinks(root) {
    (root || document).querySelectorAll('[data-whatsapp-link]').forEach((link) => {
      if (link.dataset.pairfitWhatsappInit === 'true') return;
      link.dataset.pairfitWhatsappInit = 'true';
      link.href = buildHref(link, null);
    });
  }

  function bindVariantUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data?.variant;
      const sectionId = event.data?.sectionId;
      if (!variant || !sectionId) return;

      const section = document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (!section) return;

      section.querySelectorAll('[data-whatsapp-link]').forEach((link) => {
        link.href = buildHref(link, variant.title);
      });
    });
  }

  function init() {
    initWhatsAppLinks();
    bindVariantUpdates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
